import type { PublicSiteIntegrationFlags } from "@Front/Services/PublicSiteConfig/publicSiteConfigLoader";
import { peekPublicUiOptions } from "@Front/Services/PublicSiteConfig/publicSiteConfigLoader";
import {
	DEFAULT_PUBLIC_SITE_PUBLIC_UI_OPTIONS,
	type PublicSitePublicUiOptions,
} from "@Front/Services/PublicSiteConfig/publicSiteConfigLoaderTypes";
import { usePublicSiteConfigContext } from "@Front/Services/PublicSiteConfig/usePublicUiOptions";

export type PublicIntegrationFlagsState = {
	ready: boolean;
	flags: PublicSiteIntegrationFlags;
	public_ui: PublicSitePublicUiOptions;
};

const initialFlags: PublicSiteIntegrationFlags = {
	uses_idnot: false,
	uses_docv_oauth: false,
	uses_mailchimp: false,
	uses_ovh_sms: false,
	uses_stripe: false,
	allows_v1_import: false,
};

/**
 * Drapeaux `sites` exposés par `GET /v1/public/site-config` (admin multi-site).
 * Partage le même chargement que `usePublicUiOptions` via `PublicSiteConfigProvider`.
 */
export function usePublicIntegrationFlags(): PublicIntegrationFlagsState {
	const { config } = usePublicSiteConfigContext();
	if (config === null) {
		return {
			ready: false,
			flags: initialFlags,
			public_ui: peekPublicUiOptions(),
		};
	}
	return {
		ready: true,
		flags: config.integration_flags,
		public_ui: config.public_ui ?? DEFAULT_PUBLIC_SITE_PUBLIC_UI_OPTIONS,
	};
}
